import apiCall, { makeUrl } from "../../utils/apiCall";
import { put } from "redux-saga/effects";

export function* getMyIntegrations() {
  yield put({ type: "SET_LOADING", key: "integrations", loading: true });
  const postIntegrationsCall = yield apiCall();
  const result = yield postIntegrationsCall.get(makeUrl("/my-integrations"));
  yield put({ type: "SAVE_INTEGRATIONS", integrations: result.data });
  if (window.location.pathname.match(/start-thinkific/) && result.data.thinkific.installLink) {
    window.location.href = result.data.thinkific.installLink;
  }
  yield put({ type: "SET_LOADING", key: "integrations", loading: false });
}

export function* regenerateApiKey() {
  yield put({ type: "SET_LOADING", key: "regenerate-api-key", loading: true });
  const postApiKeyCall = yield apiCall();
  const result = yield postApiKeyCall.post(makeUrl("/api-key"), {});
  yield put({
    type: "SAVE_SINGLE_INTEGRATION",
    integration: { api_key: result.data },
  });
  yield put({ type: "SET_LOADING", key: "regenerate-api-key", loading: false });
}

export function* getKitForms() {
  yield put({ type: "SET_LOADING", key: "kit-forms", loading: true });
  const getKitFormsCall = yield apiCall();
  const result = yield getKitFormsCall.get(makeUrl("/integration/kit/forms"));
  yield put({
    type: "SAVE_KIT_PRODUCTS",
    productType: "forms",
    products: result.data?.forms || [],
  });
  yield put({ type: "SET_LOADING", key: "kit-forms", loading: false });
}

export function* getKitSequences() {
  yield put({ type: "SET_LOADING", key: "kit-sequences", loading: true });
  const getKitSequencesCall = yield apiCall();
  const result = yield getKitSequencesCall.get(makeUrl("/integration/kit/sequences"));
  yield put({
    type: "SAVE_KIT_PRODUCTS",
    productType: "sequences",
    products: result.data?.sequences || [],
  });
  yield put({ type: "SET_LOADING", key: "kit-sequences", loading: false });
}

export function* getKitTags() {
  yield put({ type: "SET_LOADING", key: "kit-tags", loading: true });
  const getKitTagsCall = yield apiCall();
  const result = yield getKitTagsCall.get(makeUrl("/integration/kit/tags"));
  yield put({
    type: "SAVE_KIT_PRODUCTS",
    productType: "tags",
    products: result.data?.tags || [],
  });
  yield put({ type: "SET_LOADING", key: "kit-tags", loading: false });
}

/**
 * @param {{
 *   callback?: function;
 *   platform: string;
 *   userIntegrationTokenId: string;
 *   settingsKey: string;
 *   settingsValue: boolean | string | number | object;
 * }} param0
 */
export function* updateIntegrationSettings({
  callback,
  platform,
  userIntegrationTokenId,
  settingsKey,
  settingsValue,
}) {
  yield put({ type: "SET_LOADING", key: `integrations.${platform}`, loading: true });
  const putIntegrationsCall = yield apiCall();
  yield putIntegrationsCall.put(makeUrl(`/integration/settings`), {
    settingsKey,
    settingsValue,
    userIntegrationTokenId,
  });
  if (typeof callback === "function") {
    callback();
  }
  yield put({ type: "SET_LOADING", key: `integrations.${platform}`, loading: false });
}
